import { lazy } from 'react';
import type { ViewRegistry } from '@/app/routing/view-registry';
import { useNavigation } from '@/app/navigation/use-navigation';

const Tarefa = lazy(() => import('@/features/tarefas/components/Tarefa'));

function TarefasView() {
  const { actions } = useNavigation();
  return <Tarefa onBack={actions.goBack} />;
}

export const tarefasViews: Partial<ViewRegistry> = {
  tarefas: { component: TarefasView, guard: { screen: 'tarefas' } },
};
